import React from 'react';

import { FormattedMessage } from '../../../../util/reactIntl';

import css from './Story.module.css';

/**
 * Why the marketplace exists, and the standard providers are held to.
 */
const Story = () => (
  <section className={css.root}>
    <div className={css.inner}>
      <p className={css.text}>
        <FormattedMessage
          id="AboutStory.families"
          defaultMessage="Families are left to search through referral chains, outdated directories, and word-of-mouth recommendations at the exact moment they have the least capacity to do so. We knew there had to be a better way."
        />
      </p>
      <blockquote className={css.quote}>
        <FormattedMessage
          id="AboutStory.quote"
          defaultMessage="PostPartners is the infrastructure postpartum care has always needed."
        />
      </blockquote>
      <p className={css.text}>
        <FormattedMessage
          id="AboutStory.marketplace"
          defaultMessage="We are a vetted marketplace connecting families with the specialists who support them most in the fourth trimester and beyond: newborn care specialists, lactation consultants, postpartum doulas, pelvic floor therapists, mental health counselors, and more."
        />
      </p>
      <p className={css.text}>
        <FormattedMessage
          id="AboutStory.vetting"
          defaultMessage="Every provider on our platform has been credentialed, background-checked, and reviewed and we speak to their references against the standards we would apply to our own families."
        />
      </p>
    </div>
  </section>
);

export default Story;
